module.exports = __webpack_public_path__ + "static/media/bottom-background.70b9b4b6.png";